/*
 * Authors: mariushirjanu
 * Created: 08/04/2019
 * Upgraded: 03/10/2022
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { IUserNotifications, IUserNotificationsGroup, UserProfileDataService } from '../userprofile-data.service';
import { IUserInfo, UserProfileService } from '../user-profile.service';
import { IUserData } from '../../../shared/services/auth/auth-data.service';
import { GaEventService, IGAEvent } from '../../../shared/services/ga-event.service';
import { EVENT_USER_PROFILE_UPDATED } from '../../../shared/app-events';

@Component({
  selector: 'user-notifications',
  template: `
    <div class="notifications">

      <h2 *ngIf="loading">
        <activity-indicator toLoad="APP.USER_PROFILE.NOTIFICATIONS.EMAIL_NOTIFICATIONS"></activity-indicator>
      </h2>

      <div *ngIf="!loading" class="row block-max-width">

        <!-- Notifications section -->
        <div class="col-md-12">
          <h4 class="form-title" translate>APP.USER_PROFILE.NOTIFICATIONS.EMAIL_NOTIFICATIONS</h4>

          <table class="user-notifications table table-striped">
            <thead>
              <tr>
                <th translate>GA.GENERAL.NAME</th>
                <th translate class="text-center">GA.GENERAL.ACTIVE</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let mailNotification of model.mailNotificationGroups; trackById">
                <td>{{mailNotification.description}}</td>
                <td class="text-center"><input type="checkbox" [(ngModel)]="mailNotification.subscribed" (click)="updateUserNotifications()" /></td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>
  `
})
export class UserNotificationsComponent implements OnInit, OnDestroy {
  public fields:IExtraFieldConfigurationObject[];
  public model:{
    mailNotificationGroups:IUserNotificationsGroup[];
  } = <any>{};
  public loading:boolean;
  private userInfo:IUserInfo;
  private userProfile:IUserData;
  private eventHandler:Subscription;

  constructor(
    private gaEventService:GaEventService,
    private userProfileService:UserProfileService,
    private userProfileDataService:UserProfileDataService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.userProfileService.getUserProfilePromise()
      .then(this.initController);

    this.listen();
  }

  private listen():void {
    this.eventHandler = this.gaEventService.events?.subscribe((event:IGAEvent) => {
      if (event.name === EVENT_USER_PROFILE_UPDATED) {
        this.initController(event.data);
      }
    });
  }

  private initController = (userData:IUserData) => {
    this.userProfile = userData;
    this.userInfo = this.userProfileService.getUserInfo();

    this.fillFields();
  };

  private fillFields = ():void => {
    this.loading = true;
    this.userProfileDataService.getUserNotifications(this.userInfo?.userId)
      .then((notifications:IUserNotifications) => {
        this.model.mailNotificationGroups = notifications.mailNotificationGroups;
      })
      .finally(() => {
        this.loading = false;
      });
  };

  public updateUserNotifications():void {
    this.userProfileService.notificationsChanged(this.model);
  }

  public ngOnDestroy(): void {
    this.eventHandler.unsubscribe();
  }
}